import { Truck, Zap, Store, RotateCcw, CreditCard } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  ["How long does delivery take?", "Standard UK delivery is 2–4 working days. Next Day Delivery is available if you order before 2pm Monday to Friday."],
  ["Do you offer free delivery?", "Yes — all UK orders over £50 qualify for free standard delivery. Orders under £50 are charged at £3.99."],
  ["Can I collect my order?", "Absolutely. Choose Click & Collect at checkout and pick up free from our South Woodham Ferrers store."],
  ["What is your returns policy?", "We offer hassle-free 30-day returns on unused items in their original packaging. Contact sales@furnangling.co.uk to start a return."],
  ["Which payment methods do you accept?", "We accept all major credit and debit cards, PayPal, Apple Pay, Google Pay, and interest-free finance via Klarna and Clearpay."],
];

export default function Delivery() {
  return (
    <div className="container-furn py-12">
      <div className="mb-10 border-b border-border pb-6">
        <span className="overline">Everything you need to know</span>
        <h1 className="mt-1 font-display text-4xl font-bold uppercase tracking-tight md:text-5xl">Delivery & Returns</h1>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {[[Truck, "Standard Delivery", "Free over £50 (else £3.99). 2–4 working days."], [Zap, "Next Day Delivery", "£6.99 — order before 2pm Mon–Fri."], [Store, "Click & Collect", "Free from our SWF store."]].map(([Icon, t, d]) => (
          <div key={t} className="border border-border bg-card p-6">
            <Icon className="h-7 w-7 text-accent" />
            <h3 className="mt-3 font-display text-lg font-semibold">{t}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{d}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        <div className="border border-border bg-card p-6"><RotateCcw className="h-7 w-7 text-accent" /><h3 className="mt-3 font-display text-lg font-semibold">30-Day Returns</h3><p className="mt-2 text-sm text-muted-foreground">Changed your mind? Return unused items within 30 days for a full refund. Our returns portal makes it simple.</p></div>
        <div className="border border-border bg-card p-6"><CreditCard className="h-7 w-7 text-accent" /><h3 className="mt-3 font-display text-lg font-semibold">Finance Options</h3><p className="mt-2 text-sm text-muted-foreground">Spread the cost with Klarna and Clearpay — pay in 3 interest-free instalments on eligible orders.</p></div>
      </div>

      <div className="mt-14">
        <h2 className="mb-6 font-display text-3xl font-bold uppercase">Frequently Asked Questions</h2>
        <Accordion type="single" collapsible className="max-w-3xl">
          {faqs.map(([q, a], i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-border">
              <AccordionTrigger className="text-left font-medium">{q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
